import { useEffect, useRef } from 'react';

// Only input names/counts leave the component; never log user/query payloads.
const useRenderProbe = (name, inputs) => {
    const previous = useRef(null);
    useEffect(() => {
        if (!__DEV__) return;
        const changed = previous.current
            ? Object.keys(inputs).filter(key => !Object.is(previous.current[key], inputs[key]))
            : ['mount'];
        previous.current = inputs;
        globalThis.__reachPerformanceProbe?.recordRender(name, changed.join('+') || 'same-inputs');
    });
};

export default useRenderProbe;
